import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { URL } from '../../../redux/common/url';
import { AsyncPaginate } from 'react-select-async-paginate';
import moment from 'moment';
import axios from 'axios';
import { DatePicker } from 'antd';
import { usePDF } from 'react-to-pdf';

import './table.css';

interface Option {
    value: string;
    label: string;
}

interface PaginatedResponse {
    results: Option[];
    has_more: boolean;
}

interface Value {
    id: string;
    name: string;
}

interface InvoiceData {
    date: string;
    vehicle: {
        id: number;
        vehicle_name: string;
        registration_number?: string;
        model_year?: string;
    };
    vehicle_id: number;
    distance_0_5_km: number;
    distance_5_10_km: number;
    // distance_10_plus_km: number;
    distance_10_15_km: number;
    distance_15_20_km: number;
    distance_20_plus_km: number;
    total_trips: number;
    created_at?: string;
    updated_at?: string;
}

interface InvoiceSummary {
    circle_id: number;
    total_0_5_km_trips: number;
    rate_0_5: number;
    amount_0_5: number;
    total_5_10_km_trips: number;
    rate_5_10: number;
    amount_5_10: number;
    // total_10_plus_km_trips: number;
    // rate_10_plus: number;
    // amount_10_plus: number;
    total_10_15_km_trips: number;
    rate_10_15: number;
    amount_10_15: number;
    total_15_20_km_trips: number;
    rate_15_20: number;
    amount_15_20: number;
    total_20_plus_km_trips: number;
    rate_20_plus: number;
    amount_20_plus: number;
    grand_total: number;
}

const Vef_Invoice = () => {
    const [criId, setCriId] = useState<any>('');
    const [circles, setCircles] = useState<Value[]>([]);
    const [managerKey, setManagerKey] = useState<number>(0);
    const [managerKeyAen, setManagerKeyAen] = useState<number>(0);
    const [managerKeyJen, setManagerKeyJen] = useState<number>(0);
    const [managerKeyVendor, setManagerKeyVendor] = useState<number>(0);
    const [seleceteMangerXen, setSeleceteMangerXen] = useState<any>({});
    const [seleceteMangerAen, setSeleceteMangerAen] = useState<any>({});
    const [seleceteMangerJen, setSeleceteMangerJen] = useState<any>({});
    const [seleceteMangerVendor, setSeleceteMangerVendor] = useState<any>({});
    const [startDate, setStartDate] = useState<moment.Moment | null>(null);
    const [endDate, setEndDate] = useState<moment.Moment | null>(null);
    const [invoiceData, setInvoiceData] = useState<InvoiceData[]>([]);
    const [invoiceSummary, setInvoiceSummary] = useState<InvoiceSummary | null>(null);
    const [tpPercentage, setTpPercentage] = useState<number>(0);
    const [billNo, setBillNo] = useState<string>(`PHED-N-${moment().format('YYYYMMDD')}-`);
    const [refNo, setRefNo] = useState<string>('');
    const [gstinNo, setGstinNo] = useState<string>('');
    const [orderNo, setOrderNo] = useState<string>('');

    const options = {
        filename: 'phed_invoice.pdf',
    };

    const { toPDF, targetRef } = usePDF(options);

    const loadOptionsgetManagerXen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = await localStorage.getItem('kt-auth-react-v');
        const response = await fetch(
            `${URL.API_BASE_URL}/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${criId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        );
        const responseJSON: PaginatedResponse = await response.json();
        const options: any = responseJSON?.results?.map((data: any) => {
            data.value = data?.id;
            data.label = data?.name;
            return data;
        });
        return {
            options: options,
            hasMore: responseJSON.has_more,
            additional: {
                page: page + 1,
            },
        };
    };

    const loadOptionsgetManagerAen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = await localStorage.getItem('kt-auth-react-v');
        const response = await fetch(
            `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerXen?.id}&circle_id=${criId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        );
        const responseJSON: PaginatedResponse = await response.json();
        const options: any = responseJSON?.results?.map((data: any) => {
            data.value = data?.id;
            data.label = data?.name;
            return data;
        });
        return {
            options: options,
            hasMore: responseJSON.has_more,
            additional: {
                page: page + 1,
            },
        };
    };

    const loadOptionsgetManagerJen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = await localStorage.getItem('kt-auth-react-v');
        const response = await fetch(
            `${URL.API_BASE_URL}/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerAen?.id}&circle_id=${criId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        );
        const responseJSON: PaginatedResponse = await response.json();
        const options: any = responseJSON?.results?.map((data: any) => {
            data.value = data?.id;
            data.label = data?.name;
            return data;
        });
        return {
            options: options,
            hasMore: responseJSON.has_more,
            additional: {
                page: page + 1,
            },
        };
    };

    const loadOptionsgetManagerVendor = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = await localStorage.getItem('kt-auth-react-v');
        const response = await fetch(
            `${URL.API_BASE_URL}/api/getAllVendor?circle_id=${criId}&page=${page}&jen_id=${seleceteMangerJen.id}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        );
        const responseJSON: PaginatedResponse = await response.json();
        const options: any = responseJSON?.results?.map((data: any) => {
            data.value = data?.id;
            data.label = data?.user_name;
            return data;
        });
        return {
            options: options,
            hasMore: responseJSON.has_more,
            additional: {
                page: page + 1,
            },
        };
    };

    const fetchCircles = async () => {
        try {
            const response: any = await axios.get(`${URL.API_BASE_URL}${URL.getAllCircles}`);
            if (response?.data?.data) {
                setCircles(response?.data?.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const generateInvoice = async () => {
        if (!startDate || !endDate || !seleceteMangerVendor?.id) {
            alert('Please select start date, end date, and vendor');
            return;
        }

        try {
            const token: any = await localStorage.getItem('kt-auth-react-v');
            const response = await axios.get(URL.API_BASE_URL + URL.generateInvoice, {
                params: {
                    fromdate: startDate ? startDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                    todate: endDate ? endDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                    vendor: seleceteMangerVendor.id,
                },
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            });

            if (response.data.status) {
                setInvoiceData(response.data.data);
                setInvoiceSummary(response.data.invoice_summary);
            }
        } catch (error) {
            console.error('Error generating invoice:', error);
            alert('Failed to generate invoice');
        }
    };

    useEffect(() => {
        fetchCircles();
    }, []);

    const calculateTpAmount = () => {
        if (!invoiceSummary) return 0;
        return (invoiceSummary.grand_total * tpPercentage) / 100;
    };

    return (
        <div>
            <div className='d-flex flex-column flex-wrap justify-content-center me-3 page-title'>
                <h1 className='d-flex flex-column justify-content-center my-0 fw-bold text-dark page-heading fs-3'>
                    Generate Invoice
                </h1>
                <ul className='my-0 breadcrumb-separatorless pt-1 fw-semibold breadcrumb fs-7'>
                    <li className='breadcrumb-item text-muted'>
                        <Link to={'/'} className='text-hover-primary text-muted'>
                            Home
                        </Link>
                    </li>
                    <li className='breadcrumb-item'>
                        <span className='bg-gray-400 w-5px h-2px bullet'></span>
                    </li>
                    <li className='breadcrumb-item text-muted'>Generate Invoice</li>
                </ul>
            </div>
            <div className='mt-5 p-6 rounded card card-flush'>
                <div className='row'>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>Circle</span>
                            </label>
                            <select
                                className='bg-transparent form-control'
                                aria-label='Select example'
                                name='circle_id'
                                onChange={(e: any) => {
                                    const value = e.target.value;
                                    setCriId(value);

                                    // reset all dropdowns
                                    setSeleceteMangerXen({});
                                    setSeleceteMangerAen({});
                                    setSeleceteMangerJen({});
                                    setSeleceteMangerVendor({});

                                    // force reload
                                    setManagerKey(k => k + 1);
                                    setManagerKeyAen(k => k + 1);
                                    setManagerKeyJen(k => k + 1);
                                    setManagerKeyVendor(k => k + 1);
                                }}
                            >
                                <option value={''}>Select Circle</option>
                                {circles?.map((data, i) => (
                                    <option value={data?.id} key={i}>
                                        {data?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>Select Xen</span>
                                <i
                                    className='ms-2 fas fa-exclamation-circle fs-7'
                                    data-bs-toggle='popover'
                                    data-bs-trigger='hover'
                                    data-bs-html='true'
                                    data-bs-content='Permission names is required to be unique.'
                                ></i>
                            </label>
                            <AsyncPaginate<any, any, any>
                                key={managerKey}
                                value={seleceteMangerXen}
                                loadOptions={loadOptionsgetManagerXen}
                                onChange={(e: any) => {
                                    setSeleceteMangerXen(e);

                                    // reset children
                                    setSeleceteMangerAen({});
                                    setSeleceteMangerJen({});
                                    setSeleceteMangerVendor({});

                                    // reload children
                                    setManagerKeyAen(k => k + 1);
                                    setManagerKeyJen(k => k + 1);
                                    setManagerKeyVendor(k => k + 1);
                                }}
                                additional={{
                                    page: 1,
                                }}
                                className='bg-transparent form-control'
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>Select Aen</span>
                                <i
                                    className='ms-2 fas fa-exclamation-circle fs-7'
                                    data-bs-toggle='popover'
                                    data-bs-trigger='hover'
                                    data-bs-html='true'
                                    data-bs-content='Permission names is required to be unique.'
                                ></i>
                            </label>
                            <AsyncPaginate<any, any, any>
                                key={managerKeyAen}
                                value={seleceteMangerAen}
                                loadOptions={loadOptionsgetManagerAen}
                                onChange={(e: any) => {
                                    setSeleceteMangerAen(e);
                                    setSeleceteMangerJen({});
                                    setSeleceteMangerVendor({});
                                    setManagerKeyJen(k => k + 1);
                                    setManagerKeyVendor(k => k + 1);
                                }}
                                additional={{
                                    page: 1,
                                }}
                                className='bg-transparent form-control'
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>Select Jen</span>
                                <i
                                    className='ms-2 fas fa-exclamation-circle fs-7'
                                    data-bs-toggle='popover'
                                    data-bs-trigger='hover'
                                    data-bs-html='true'
                                    data-bs-content='Permission names is required to be unique.'
                                ></i>
                            </label>
                            <AsyncPaginate<any, any, any>
                                key={managerKeyJen}
                                value={seleceteMangerJen}
                                loadOptions={loadOptionsgetManagerJen}
                                onChange={(e: any) => {
                                    setSeleceteMangerJen(e);
                                    setSeleceteMangerVendor({});
                                    setManagerKeyVendor(k => k + 1);
                                }}
                                additional={{
                                    page: 1,
                                }}
                                className='bg-transparent form-control'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>Vendor</span>
                            </label>
                            <AsyncPaginate<any, any, any>
                                key={managerKeyVendor}
                                value={seleceteMangerVendor}
                                loadOptions={loadOptionsgetManagerVendor}
                                onChange={setSeleceteMangerVendor}
                                additional={{
                                    page: 1,
                                }}
                                className='bg-transparent form-control'
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>TP (%)</span>
                            </label>
                            <input
                                type="number"
                                name="tp"
                                className="form-control"
                                onChange={(e) => setTpPercentage(Number(e.target.value))}
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>Start Date</span>
                            </label>
                            <DatePicker
                                onChange={(date) => setStartDate(date)}
                                value={startDate}
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>End Date</span>
                            </label>
                            <DatePicker
                                onChange={(date) => setEndDate(date)}
                                value={endDate}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span>Bill No</span>
                            </label>
                            <input
                                type="text"
                                name="billNo"
                                className="form-control"
                                value={billNo}
                                onChange={(e) => setBillNo(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span>Ref No</span>
                            </label>
                            <input
                                type="text"
                                name="refNo"
                                className="form-control"
                                value={refNo}
                                onChange={(e) => setRefNo(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span>GSTIN No</span>
                            </label>
                            <input
                                type="text"
                                name="gstinNo"
                                className="form-control"
                                value={gstinNo}
                                onChange={(e) => setGstinNo(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span>Order No</span>
                            </label>
                            <input
                                type="text"
                                name="orderNo"
                                className="form-control"
                                value={orderNo}
                                onChange={(e) => setOrderNo(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='row' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div
                        className="mt-8 btn btn-success"
                        style={{ backgroundColor: 'green', color: 'white', height: '30px', width: '250px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        onClick={generateInvoice}
                    >
                        Generate
                    </div>
                </div>
            </div>
            <button onClick={() => toPDF()}>Download PDF</button>
            <div className='mt-10 p-6 rounded card card-flush'>
                <div className='body' ref={targetRef}>
                    <div className="header">
                        <div>GSTIN NO: {gstinNo || '_______________________________'}</div>
                        <div className="box">
                            {seleceteMangerVendor?.user_name || ""}
                        </div>
                        <div>Ref No. {refNo || '_______________________'}</div>
                        <div>The Executive Engineer : {seleceteMangerXen?.user_name || "--"}</div>
                        <div className="ak">
                            <div>Dated: {moment().format('DD-MM-YYYY')}</div>
                        </div>
                        <div>BILL NO: {billNo || `PHED-N-${moment().format('YYYYMMDD')}-_______`}</div>
                        <div>Dated: {moment().format('DD-MM-YYYY')}</div>
                        <div className="ak">
                            <div>Order No. {orderNo || '____________________________________'}</div>
                            <div>Period: {startDate ? startDate.format('DD-MMM-YYYY') : 'N/A'} To {endDate ? endDate.format('DD-MMM-YYYY') : 'N/A'}</div>                        </div>
                        <div style={{ marginTop: '10px' }}>
                            Transportation work of drinking water through tanker under the jurisdiction of RRJ
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>S.NO</th>
                                <th>DATE</th>
                                {/* <th>VEHICLE</th> */}
                                <th>TANKER TRAVEL DISTANCE FROM 0 TO 5 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM 5 TO 10 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM 10 TO 15 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM 15 TO 20 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM ABOVE 20 KMS.</th>
                                {/* <th>TANKER TRAVEL DISTANCE FROM ABOVE 10 KMS.</th> */}
                                <th>TOTAL TRIP</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceData.map((item, index) => (
                                <tr key={item.vehicle_id + item.date}>
                                    <td>{index + 1}</td>
                                    <td>{moment(item.date).format('YYYY-MM-DD')}</td>
                                    {/* <td>{item.vehicle.vehicle_name}</td> */}
                                    <td>{item.distance_0_5_km}</td>
                                    <td>{item.distance_5_10_km}</td>
                                    <td>{item.distance_10_15_km}</td>
                                    <td>{item.distance_15_20_km}</td>
                                    <td>{item.distance_20_plus_km}</td>
                                    {/* <td>{item.distance_10_plus_km}</td> */}
                                    <td>{item.total_trips}</td>
                                </tr>
                            ))}
                        </tbody>
                        {invoiceSummary && (
                            <tfoot>
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Total 0-5 Kms Amount</td>
                                    <td>{invoiceSummary.total_0_5_km_trips} X {invoiceSummary.rate_0_5.toFixed(2)} =</td>
                                    <td>{invoiceSummary.amount_0_5.toFixed(2)}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Total 5-10 Kms Amount</td>
                                    <td>{invoiceSummary.total_5_10_km_trips} X {invoiceSummary.rate_5_10.toFixed(2)} =</td>
                                    <td>{invoiceSummary.amount_5_10.toFixed(2)}</td>
                                </tr>
                                {/* <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Total Above 10 Kms Amount</td>
                                    <td>{invoiceSummary.total_10_plus_km_trips} X {invoiceSummary.rate_10_plus.toFixed(2)} =</td>
                                    <td>{invoiceSummary.amount_10_plus.toFixed(2)}</td>
                                </tr> */}
                                {/* New Fields - 10 to 15 km */}
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Total 10-15 Kms Amount</td>
                                    <td>
                                        {invoiceSummary.total_10_15_km_trips} × {invoiceSummary.rate_10_15?.toFixed(2) || '0.00'} =
                                    </td>
                                    <td>{invoiceSummary.amount_10_15?.toFixed(2) || '0.00'}</td>
                                </tr>

                                {/* New Fields - 15 to 20 km */}
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Total 15-20 Kms Amount</td>
                                    <td>
                                        {invoiceSummary.total_15_20_km_trips} × {invoiceSummary.rate_15_20?.toFixed(2) || '0.00'} =
                                    </td>
                                    <td>{invoiceSummary.amount_15_20?.toFixed(2) || '0.00'}</td>
                                </tr>

                                {/* New Fields - 20 and above km */}
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Total 20+ Kms Amount</td>
                                    <td>
                                        {invoiceSummary.total_20_plus_km_trips} × {invoiceSummary.rate_20_plus?.toFixed(2) || '0.00'} =
                                    </td>
                                    <td>{invoiceSummary.amount_20_plus?.toFixed(2) || '0.00'}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Trip Total Amount</td>
                                    <td></td>
                                    <td>{invoiceSummary.grand_total.toFixed(2)}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>TP {tpPercentage}% Above</td>
                                    <td></td>
                                    <td>{calculateTpAmount().toFixed(2)}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Grand Total (Payable) Amount</b></td>
                                    <td></td>
                                    <td>{(invoiceSummary.grand_total + calculateTpAmount()).toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        )}
                    </table>
                    <p className='text-center'>--- This is a system generated invoice and does not required any signature or stamp ---</p>
                </div>
            </div>
        </div>
    );
};

export default Vef_Invoice;